import { apiClient } from './client';
import { LoginCredentials, RegisterData, AuthResponse } from '../../types/auth.types';
import { User } from '../../types/user.types';

export const authService = {
  login: (credentials: LoginCredentials): Promise<AuthResponse> =>
    apiClient.post('/auth/login', credentials),

  register: (data: RegisterData): Promise<AuthResponse> =>
    apiClient.post('/auth/register', data),

  me: (): Promise<User> =>
    apiClient.get('/auth/profile'),

  logout: (): Promise<void> =>
    apiClient.post('/auth/logout'),
};